import { asyncRouterMap, constantRouterMap } from '@/router'

/**
 * @param roles
 * @param route
 */
function hasPermission(permission, route) {
  if (route.meta && route.meta.role) {
    return permission.indexOf('|' + route.meta.role + '|') !== -1
  } else {
    return true
  }
}

/**
 * @param routes asyncRouterMap
 * @param roles
 */
function filterAsyncRouter(routes, permission) {
  const res = []
  routes.forEach(route => {
    const tmp = { ...route }
    if (hasPermission(permission, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRouter(tmp.children, permission)
      }
      res.push(tmp)
    }
  })

  return res
}

const getDefaultState = () => {
  return {
    routers: constantRouterMap,
    addedRouters: []
  }
}

const permission = {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addedRouters = routers
      state.routers = constantRouterMap.concat(routers)
    },
    RESET_STORE: (state) => {
      Object.assign(state, getDefaultState())
    }
  },
  actions: {
    GenerateRoutes({ commit }, data) {
      return new Promise(resolve => {
        const  { roles, isAdmin } = data
        let accessedRouters
        if (isAdmin === 1) {
          accessedRouters = asyncRouterMap
        } else {
          accessedRouters = filterAsyncRouter(asyncRouterMap, roles)
        }
        /*
        if (roles.indexOf('|adminUserEdit|') !== -1 || isAdmin === 1) {
          let idx = accessedRouters.findIndex(item => typeof item.userProfile !== 'undefined' &&  item.userProfile )
          accessedRouters.splice(idx, 1)
        }
        */
        commit('SET_ROUTERS', accessedRouters)
        resolve(accessedRouters)
      })
    }
  }
}

export default permission
